import React from 'react';
import { createSvgIcon } from '@mui/material';

const CustomCommentsOutlined = createSvgIcon(
  <path d="M7.703 8.916c-.703 0-1.21.59-1.21 1.258 0 .707.546 1.257 1.21 1.257s1.211-.55 1.211-1.257c0-.669-.508-1.258-1.21-1.258Zm4.375 0c-.703 0-1.25.59-1.25 1.258 0 .707.547 1.257 1.25 1.257s1.211-.55 1.211-1.257c0-.669-.508-1.258-1.21-1.258Zm4.375 0c-.703 0-1.21.59-1.21 1.258 0 .707.546 1.257 1.21 1.257s1.211-.55 1.211-1.257c0-.669-.508-1.258-1.21-1.258ZM19.5 2h-15A2.5 2.5 0 0 0 2 4.515v11.278c0 1.375 1.094 2.475 2.5 2.475h3.75v3.262c0 .393.43.59.742.393l4.883-3.694H19.5c1.367 0 2.5-1.14 2.5-2.475V4.514A2.5 2.5 0 0 0 19.5 2m.664 13.832a.644.644 0 0 1-.625.629h-6.25l-3.125 2.358V16.46H4.54a.62.62 0 0 1-.625-.629V4.515c0-.314.273-.629.625-.629h15c.313 0 .625.315.625.629z" />,
  'CustomCommentsOutlined',
);

export default CustomCommentsOutlined;
